import { Schoolyear } from 'types/schoolyear';
import { isDefined } from 'types/utils';
import addDays from 'utils/time/addDays';
import differenceInDays from 'utils/time/differenceInDays';
import isAfter from 'utils/time/isAfter';
import isBefore from 'utils/time/isBefore';
import setYear from 'utils/time/setYear';

function getSchoolyearPeriodeRange(schoolyear: Schoolyear):
  | {
      schoolyearStart: Date;
      schoolyearEnd: Date;
    }
  | undefined {
  const periodes = schoolyear.zone?.periodes || [];
  const datesFrom = periodes.map(p => p.from).filter(isDefined);
  const datesTo = periodes.map(p => p.to).filter(isDefined);

  const schoolyearStart =
    datesFrom.length > 0
      ? datesFrom.reduce((a, b) => (a < b ? a : b))
      : undefined;
  const schoolyearEnd =
    datesTo.length > 0 ? datesTo.reduce((a, b) => (a > b ? a : b)) : undefined;

  if (
    schoolyearStart &&
    schoolyearEnd &&
    differenceInDays(schoolyearEnd, schoolyearStart) > 30 // safe guard
  ) {
    return { schoolyearStart, schoolyearEnd };
  }
  return undefined;
}

function isInSchoolyearRange(start: Date, end: Date, day: Date) {
  // 6 weeks before and 2 weeks after considered in range
  return (
    isAfter(day, addDays(start, -6 * 7)) && isBefore(day, addDays(end, 2 * 7))
  );
}

function getCurrentDayForSchoolyear(
  day: Date,
  schoolyear: Schoolyear,
): Date | undefined {
  const schoolyearRange = getSchoolyearPeriodeRange(schoolyear);

  if (schoolyearRange) {
    const { schoolyearStart, schoolyearEnd } = schoolyearRange;
    // the easiest way to find the right year is to try the previous/current/next calendar year
    // and return it if it's in the schoolyear range
    const targetDate = [-1, 0, 1]
      .map(offset => setYear(day, schoolyear.year + offset))
      .find(d => isInSchoolyearRange(schoolyearStart, schoolyearEnd, d));
    if (targetDate) {
      return targetDate;
    }
  }

  return undefined;
}

export { getCurrentDayForSchoolyear };
